module.exports = __webpack_public_path__ + "static/media/admin-speed.884f584d.png";